import { action } from 'mobx';
import { BaseEditViewStore, BaasicDropdownStore } from 'core/stores';
import { EditFacilityOrderTemplateInactiveReasonForm } from 'application/facility-order/forms';
import { FacilityOrderTemplateService } from "application/facility-order/services";
import { inactiveReasons } from 'core/constants';
class EditFacilityOrderTemplateInactiveReasonModalStore extends BaseEditViewStore {
    constructor(rootStore, componentProps) {
        const facilityOrderTemplateService = new FacilityOrderTemplateService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'edit-facility-order-template-inactive-reason-modal',
            Form: EditFacilityOrderTemplateInactiveReasonForm,
            actions: () => {
                return {
                    update: async (resource) => {
                        const response = await facilityOrderTemplateService.updateInactiveReason(resource);
                        return response.data;
                    }
                }
            },
            FormClass: EditFacilityOrderTemplateInactiveReasonForm
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;

        this.patientId = this.modalParams.data.patientId;
        this.facilityOrderId = this.modalParams.data.facilityOrderId;
        this.setFacilityOrderTemplateList = this.modalParams.data.setFacilityOrderTemplateList;
        this.inactiveReasonStore = new BaasicDropdownStore();
        const inactiveReasonIds = ["15", "17", "18", "0"];
        let filteredInactiveReasons = inactiveReasons.filter(i => {
            return inactiveReasonIds.some(id => i.id === id);
        });
        this.inactiveReasonStore.setItems(filteredInactiveReasons);
        this.checkAreTemplatesLinkedWithSpecificAreaOfCare = this.modalParams.data.checkAreTemplatesLinkedWithSpecificAreaOfCare;
    }

    @action.bound
    async createResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);

        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.update({
                ...resource,
                facilityOrderId: this.facilityOrderId,
                patientId: this.patientId
            });

            this.form.setFieldsDisabled(false);
            this.setFacilityOrderTemplateList();

            this.checkAreTemplatesLinkedWithSpecificAreaOfCare();

            this.modalParams.close();
            this.rootStore.notificationStore.success('Facility order templates successfully updated.');
        } 
        catch(err) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error('Error occured while trying to update facility order templates.');
        }
    }
}

export default EditFacilityOrderTemplateInactiveReasonModalStore;
